import { Stack } from "@mui/material";
import MDButton from "components/MDButton";
import { Job, OrganizationLinkedServiceName, Proposal, Organization } from "generated/graphql";
import useGetOrganization from "hooks/organization/useGetOrganization";
import CreateChangeOrder from "modules/proposals/buttons/CreateChangeOrder/CreateChangeOrder";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";
import Modal from "../Modal/Modal";
import useModalState from "hooks/useModalState";
import QuickbooksConfirmationModal from "./Modals/QuickbooksConfirmationModal";
import SendInvoice from "./SendInvoice/SendInvoice";
import JobChecklist from "./buttons/JobChecklist/JobChecklist";

export default function StackSection({
  proposalId,
  jobId,
  job,
  shouldPushTaxesToQuickbooks,
  proposal,
  mayShowTaxNotification,
  externalId,
}: {
  proposalId: Proposal["id"];
  jobId: Job["id"];
  job: Job;
  shouldPushTaxesToQuickbooks?: Boolean;
  mayShowTaxNotification?: Boolean;
  proposal: Partial<Proposal>;
  externalId: string;
}) {
  const { data } = useGetOrganization();
  const { open, onClose, onOpen } = useModalState();
  const hasLinkedQuickbooksDesktop = !!data?.linkedServices?.find(
    (service) =>
      service.service === OrganizationLinkedServiceName.QUICKBOOKS_DESKTOP && service.active
  );

  const hasLinkedQuickbooksOnline = !!data?.linkedServices?.find(
    (service) => service.service === OrganizationLinkedServiceName.QUICKBOOKS && service.active
  );

  return (
    <Stack direction="row" spacing={5} justifyContent="center">
      <MDButton
        color="success"
        disabled={!hasLinkedQuickbooksOnline && !hasLinkedQuickbooksDesktop}
        onClick={onOpen}
      >
        Sync with Quickbooks
      </MDButton>
      <Modal
        open={open}
        onClose={onClose}
        styles={{ maxWidth: "1440px", overflow: "auto", height: "90vh", width: "94vw" }}
      >
        <QuickbooksConfirmationModal
          proposalId={proposalId}
          externalId={externalId}
          job={job}
          organization={data as Organization}
          shouldPushTaxesToQuickbooks={shouldPushTaxesToQuickbooks}
          mayShowTaxNotification={mayShowTaxNotification}
          onClose={onClose}
        />
      </Modal>
      {data && (
        <SendInvoice job={job} proposalId={proposalId} organization={data as Organization} />
      )}
      <MDButton
        component={Link}
        to={getRoute("proposals.draft", [["proposalId", proposalId]])}
        color="success"
      >
        View Proposal
      </MDButton>
      <MDButton
        component={Link}
        to={`/jobs/schedule?jobId=${jobId}&externalId=${externalId}`}
        variant="contained"
        color="success"
      >
        Schedule
      </MDButton>
      <JobChecklist job={job} />
    </Stack>
  );
}
